module.exports = __webpack_public_path__ + "static/media/counter-red.75776df6.png";